/**
 * Express API base URL (includes `/api/v1`).
 * Server-side (SSR, no `window`) always hits the backend directly on the same
 * container — a relative URL has no origin to resolve against in Node and
 * throws ERR_INVALID_URL. Client-side uses the public env var (relative path,
 * resolved against whatever domain the browser is on).
 */
export const API_BASE_URL =
  typeof window === "undefined"
    ? "http://127.0.0.1:5010/api/v1"
    : (process.env.NEXT_PUBLIC_API_BASE_URL ?? "/api/v1");

/** Socket.io origin (HTTP server root, no `/api/v1`). */
export const SOCKET_ORIGIN = API_BASE_URL.replace(/\/api\/v1\/?$/, "");

export const ACCESS_COOKIE = "wp_at";
export const REFRESH_COOKIE = "wp_rt";

/** Access JWT lifetime — mirrors backend `ACCESS_TOKEN_TTL` default. */
export const ACCESS_COOKIE_MAX_AGE_SEC = 15 * 60;

/** Refresh token lifetime — mirrors backend `REFRESH_TOKEN_TTL_DAYS` default. */
export const REFRESH_COOKIE_MAX_AGE_SEC = 30 * 24 * 60 * 60;

export function cookieBaseOptions() {
  const secure = process.env.NODE_ENV === "production";
  return { path: "/", sameSite: "lax" as const, secure };
}
